//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetOcrAccountsService } from "@/features/accounts/ocr/services/get-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useGetOcrAccountStates } from "@/features/accounts/ocr/hooks/use-get-accounts-states";
import { useContext } from "react";


export const useGetOcrAccount = () => {
  const {
    ocrAccounts,
    setOcrAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useGetOcrAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getOcrAccountsService = new GetOcrAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // OCR口座一覧取得
  const getOcrAccounts = async (
    accountGroupId: string,
    ocrAccountId?: string
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const resOcrAccounts = await getOcrAccountsService.getOcrAccounts({
        account_group_id: accountGroupId,
        ...(ocrAccountId !== undefined && { ocr_account_id: ocrAccountId }),
      });

      // 成功時の処理
      setOcrAccounts(resOcrAccounts);
      return resOcrAccounts;
    } catch (error) {
      // エラーハンドリング
      console.log("getOcrAccounts", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    ocrAccounts,
    setOcrAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
    getOcrAccounts: errorHandledAsync(getOcrAccounts, setError),
  };
};
